import { render } from "./ProjectsPage.vue?vue&type=template&id=8e96c83a&ts=true"
import script from "./ProjectsPage.ts?vue&type=script&lang=ts"
export * from "./ProjectsPage.ts?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__